import React from 'react';
import { useAnalytics } from '../utils/Analytics';
import { LanguageProvider } from './contexts/LanguageContext';
import { AppContent } from './components/AppContent';

function App() {
    useAnalytics();

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-violet-50">
            <LanguageProvider>
                <AppContent />
            </LanguageProvider>
        </div>
    );
}

export default App; 